/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsCreateSuiteVersion } from "../../funcs/llmEvalsCreateSuiteVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateEvalSuiteVersionRequest$inboundSchema,
};

export const tool$llmEvalsCreateSuiteVersion: ToolDefinition<typeof args> = {
  name: "llm-evals-create-suite-version",
  description: `Create an eval suite version

Creates an immutable suite version. Use this endpoint for edits to an existing eval suite.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsCreateSuiteVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
